var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5171 21.9289V39.7789M32.5171 50.6589V50.9986M63.5 24.751V48.0069C63.5 51.8149 61.4527 55.3509 58.1428 57.2889L37.8743 68.9509C34.5644 70.8549 30.4698 70.8549 27.1258 68.9509L6.85721 57.2889C3.54736 55.3849 1.5 51.8489 1.5 48.0069V24.751C1.5 20.943 3.54736 17.4069 6.85721 15.4689L27.1258 3.80691C30.4357 1.90291 34.5303 1.90291 37.8743 3.80691L58.1428 15.4689C61.4527 17.4069 63.5 20.909 63.5 24.751Z",
    stroke: "#63C0DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.26d34620a83bdbc1253134969fd9f0bb.svg";
export { ForwardRef as ReactComponent };